import React, { useEffect, useState } from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import { toast } from "react-toastify";
import { patchFile, uploadFiles } from "../../../services/fileServices";
import { BlurSpinner } from "../../../components/BlurSpinner";
import { handleErrors } from "../../../services/handleErrors";
import { ButtonPrimary } from "../../../ui/buttons";

const FormatearTextoEstado = (estado) => {
  switch (estado) {
    case 9:
      return "Pre Cancelar";
    case 6:
      return "Anular";
    default:
      return "";
  }
};

const BackupFileModal = ({ toggle, isOpen, handleAnularCancelar, estado, id, handleCancelarMotivo }) => {
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);
  const [fileName, setFileName] = useState("Seleccione un archivo");
  const [fileId, setFileId] = useState(false);
  useEffect(() => {
    setFileId(false);
    setFileName("Seleccione un archivo");
  }, [isOpen]);

  const uploadOrPatchFiles = async (entityId, files) => {
    setIsLoadingFiles(true);

    try {
      if (fileId !== false) {
        const file = await patchFile({ entity: "notaDePedido", entityId, fileId, files });
        setFileId(file.result.id);
      } else {
        const file = await uploadFiles({ entity: "notaDePedido", entityId, files });
        setFileId(file.result[0].id);
      }
    } catch (error) {
      handleErrors(error, toast.error);
    }
    setIsLoadingFiles(false);
  };
  const handleFileChange = async (e) => {
    const selectedFiles = e.target.files;
    setFileName(selectedFiles[0].name);
    try {
      await uploadOrPatchFiles(id, selectedFiles);
      toast.success("Archivo subido exitosamente");
    } catch (error) {
      handleErrors(error, toast.error);
    }
  };
  const handleClickAnular = async () => {
    if (estado === 6) {
      handleAnularCancelar(estado);
    } else if (estado === 9) {
      handleCancelarMotivo();
    }
    toggle();
  };

  return (
    <div>
      <Modal isOpen={isOpen}>
        <ModalBody>
          <>
            <div className="px-4 pt-4">
              <p style={{ fontSize: "18px", fontFamily: "Nunito" }}>
                Debe subir un archivo de respaldo para <span style={{ fontWeight: "bold" }}>{FormatearTextoEstado(estado)}</span>
              </p>
            </div>
            <BlurSpinner isLoading={isLoadingFiles}>
              <div className="col-md-10">
                <div className="">
                  <div className="form-group d-flex justify-content-center align-items-center mb-3">
                    <div className="custom-file">
                      <input
                        className="custom-file-input"
                        type="file"
                        id="upfile"
                        onChange={handleFileChange}
                        accept="application/pdf"
                        style={{ cursor: "pointer", border: "none" }}
                      />
                      <label className="custom-file-label" htmlFor="upfile">
                        {fileName}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </BlurSpinner>
          </>
        </ModalBody>

        <ModalFooter>
          <Button color="btn-secondary" onClick={toggle} type="button">
            Cancelar
          </Button>
          <ButtonPrimary onClick={handleClickAnular} type="button" disabled={isLoadingFiles || !fileId}>
            Confirmar
          </ButtonPrimary>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default BackupFileModal;
